import http from '@/utils/httpRequest';

const getReWardSingleData = (params) => {
    return http.get('/subject/reward/get?id=' + params, { baseURL: baseURL })
}
const getReWardListData = (params) => {
    return http.post('/subject/reward/list', { ...params }, { baseURL: baseURL })
}
const deleteRewardData = (params) => {
    return http.post('/subject/reward/delete', { ...params }, { baseURL: baseURL })
}
const addOrUpdateRewardData = (params) => {
    return http.post('/subject/reward/save', { ...params }, { baseURL: baseURL })
}
const commitRewardData = (params) => {
    return http.post('/subject/reward/commit', { ...params }, { baseURL: baseURL })
}


const getIllegalSingleData = (params) => {
    return http.get('/subject/illegal/get?id=' + params, { baseURL: baseURL })
}
const getIllegalListData = (params) => {
    return http.post('/subject/illegal/list', { ...params }, { baseURL: baseURL })
}
const deleteIllegalData = (params) => {
    return http.post('/subject/illegal/delete', { ...params }, { baseURL: baseURL })
}
const addOrUpdateIllegalData = (params) => {
    return http.post('/subject/illegal/saveData', { ...params }, { baseURL: baseURL })
}
const commitIllegalData = (params) => {
    return http.post('/subject/illegal/commit', { ...params }, { baseURL: baseURL })
}

const handleMainCreditRepeal = (params) => {
    return http.post('/subject/revoke/save', { ...params }, { baseURL: baseURL })
}

const getListSubjectRoleIndex = (params) => {
    return http.get("/subjectevaluateindex/listSubjectRoleIndex", { baseURL: baseURL })
}
const getIndicatorsListData = (params) => {
    return http.get("/subjectevaluateindex/list?roleType=" + params.type + "&tradeId=" + params.tradeId, { baseURL: baseURL })
}
const getIndicatorsSaveData = (params) => {
    return http.post("/subjectevaluateindex/save", { ...params }, { baseURL: baseURL })
}
const setChangeSort = (params) => {
    return http.get(`/subjectevaluateindex/changeSort?id=${params.id}&type=${params.type}`, { baseURL: baseURL })
}
const getSubjectevaluateOption = (params) => {
    return http.post("/subjectevaluateconfig/list", { ...params }, { baseURL: baseURL })
}
const getSubjectevaluateindex = (params) => {
    return http.get(`/subjectevaluateindex/get?id=${params}`, { baseURL: baseURL })
}
///subjectevaluateindex/save
const subjectevaluateindexDelete = (params) => {
    return http.post("/subjectevaluateindex/delete", { ...params }, { baseURL: baseURL })
}
// 主体评价档案
const evaluateArchiveList = (params) => {
    return http.post("/subject/evaluateArchive/list", { ...params }, { baseURL: baseURL })
}
const evaluateArchiveSave = (params) => {
    return http.post("/subject/evaluateArchive/save", { ...params }, { baseURL: baseURL })
}
// 
const evaluateArchiveSubmit = (params) => {
    return http.post("/subject/evaluateArchive/submit", { ...params }, { baseURL: baseURL })
}

const getEvaluateArchive = (params) => {
    return http.get(`/subject/evaluateArchive/get?id=${params}`, { baseURL: baseURL })
}

const evaluateArchiveDelete = (params) => {
    return http.post("/subject/evaluateArchive/delete", { ...params }, { baseURL: baseURL })
}
const getBidOrProjectByCode = (params) => {
    return http.get(`/subject/evaluateArchive/getBidOrProjectByCode?type=${params.type}&code=${params.code}`, { baseURL: baseURL })
}
const getSubjectInformation = (params) => {
    return http.get(`/subject/evaluateArchive/getSubjectInformation?code=${params.code}&type=${params.type}`, { baseURL: baseURL })
}
const getDataSetCodeList = (params) => {
    return http.get(`/subject/evaluateModel/getDataSetCodeList?evaluatedRoleType=${params}`, { baseURL: baseURL })
}
// 档案分页
const getBidOrProjectPaged = (params) => {
    return http.post("/subject/evaluateArchive/getBidOrProjectPaged", { ...params }, { baseURL: baseURL })
}
// 获取星星等分数数据
const getEvaluateModelList = (params) => {
    return http.post("/subject/evaluateModel/getModel", { ...params }, { baseURL: baseURL })
}
//撤回
const getWithdraw = (params) => {
    return http.post("/subject/evaluateArchive/withdraw", { ...params }, { baseURL: baseURL })
}
// 信用报告
const getEntityInfoList = (params) => {
    return http.post("/entityInfo/list", { ...params }, { baseURL: baseURL })
}
const getDownloadCount = (params) => {
    return http.get(`/entityInfo/downloadCount?`, { baseURL: baseURL })
}
const getPdfEntityInfo = (params) => {
    return http.get(`/entityInfo/getPdfEntityInfo?id=${params}`, { baseURL: baseURL })
}
const setDownloadFileCount = (params) => {
    return http.get(`/entityInfo/recordDownloadFile?id=${params}`, { baseURL: baseURL })
}


const getPortalSystemListData = (params) => {
    return http.post('/credit/portalsystem/list', { ...params }, { baseURL: baseURL })
}
const savePortalSystemListData = (params) => {
    return http.post('/credit/portalsystem/save', { ...params }, { baseURL: baseURL })
}
const portalSystemDetail = (id) => {
    return http.get('/credit/portalsystem/get?id=' + id, {}, { baseURL: baseURL })
}
const submitPortalSystemListData = (id) => {
    return http.get('/credit/portalsystem/submit?id=' + id, {}, { baseURL: baseURL })
}
const deletePortalSystemListData = (id) => {
    return http.post('/credit/portalsystem/delete', { id }, { baseURL: baseURL })
}
// 信息发布
const getInfomationPublishListData = (params) => {
    return http.post('/credit/portalInformationRelease/list', { ...params }, { baseURL: baseURL })
}
const saveInfomationPublishData = (params) => {
    return http.post('/credit/portalInformationRelease/save', { ...params }, { baseURL: baseURL })
}
const getInfomationPublishDetail = (id) => {
    return http.get('/credit/portalInformationRelease/get?id=' + id, {}, { baseURL: baseURL })
}
const submitInfomationPublishData = (id) => {
    return http.get('/credit/portalInformationRelease/submit?id=' + id, {}, { baseURL: baseURL })
}
const deleteInfomationPublishData = (id) => {
    return http.post('/credit/portalInformationRelease/delete', { id }, { baseURL: baseURL })
}
const revokeInfomationPublishData = (id) => {
    return http.get('/credit/portalInformationRelease/revoke?id=' + id, {}, { baseURL: baseURL })
}

// 政策法规
const getPortalPoliciesRegulationListData = (params) => {
    return http.post('/credit/portalPoliciesRegulation/list', { ...params }, { baseURL: baseURL })
}
const savePortalPoliciesRegulationData = (params) => {
    return http.post('/credit/portalPoliciesRegulation/save', { ...params }, { baseURL: baseURL })
}
const getPortalPoliciesRegulationDetail = (id) => {
    return http.get('/credit/portalPoliciesRegulation/get?id=' + id, {}, { baseURL: baseURL })
}
const submitPortalPoliciesRegulationData = (id) => {
    return http.get('/credit/portalPoliciesRegulation/submit?id=' + id, {}, { baseURL: baseURL })
}
const deletePortalPoliciesRegulationData = (id) => {
    return http.post('/credit/portalPoliciesRegulation/delete', { id }, { baseURL: baseURL })
}
const revokePortalPoliciesRegulationData = (id) => {
    return http.get('/credit/portalPoliciesRegulation/revoke?id=' + id, {}, { baseURL: baseURL })
}
const getPortalAdministrativePenaltiesListData = (params) => {
    return http.post('/credit/portaladministrativepenalties/list', { ...params }, { baseURL: baseURL })
}
const savePortalAdministrativePenaltiesListData = (params) => {
    return http.post('/credit/portaladministrativepenalties/save', { ...params }, { baseURL: baseURL })
}
const portalAdministrativePenaltiesDetail = (id) => {
    return http.get('/credit/portaladministrativepenalties/get?id=' + id, {}, { baseURL: baseURL })
}
const submitPortalAdministrativePenaltiesListData = (id) => {
    return http.get('/credit/portaladministrativepenalties/submit?id=' + id, {}, { baseURL: baseURL })
}
const deletePortalAdministrativePenaltiesListData = (id) => {
    return http.post('/credit/portaladministrativepenalties/delete', { id }, { baseURL: baseURL })
}

export {
    getReWardSingleData, //  主体奖惩信息 单条查询
    getReWardListData,// 主体奖惩信息 列表查询
    deleteRewardData,// 主体奖惩信息 删除
    addOrUpdateRewardData,// 主体奖惩信息 增改
    commitRewardData,// 主体奖惩信息 提交
    getIllegalSingleData,// 主体违法行为 单条查询
    getIllegalListData,// 主体违法行为 列表查询
    deleteIllegalData,// 主体违法行为 删除
    addOrUpdateIllegalData,// 主体违法行为 增改
    commitIllegalData,// 主体违法行为 提交
    handleMainCreditRepeal,// 主体信用信息 撤销
    getIndicatorsListData,// 主体信用评价指标列表
    getIndicatorsSaveData, // 主体信用评价指标保存
    getListSubjectRoleIndex,//主体信用评价查询角色及数量
    setChangeSort, // 排序
    getSubjectevaluateOption,// 主体信用评价方式选项
    getSubjectevaluateindex, // 主体信用评价获取单条记录
    subjectevaluateindexDelete,// // 主体信用评价 删除
    evaluateArchiveList,// 主体评价档案列表
    evaluateArchiveSave,// 主体评价档案保存更新
    evaluateArchiveSubmit,// 主体评价档案提交
    getEvaluateArchive,// 主体评价档案 获取单条数据
    evaluateArchiveDelete,// 主体评价档案删除
    getBidOrProjectByCode,// 主体评价档案 根据编码获取标段信息或者招标项目信息  单条
    getSubjectInformation,// 主体评价档案 根据项目或标段信息获取被评价人信息
    getDataSetCodeList,//获取可选的评价触发业务节点
    getBidOrProjectPaged,// 主体评价档案 分页
    getEvaluateModelList,//获取星星组件列表数据（接口为模型库列表接口）
    getWithdraw,
    getEntityInfoList,//信用报告
    getDownloadCount,
    getPdfEntityInfo,
    setDownloadFileCount,

    getPortalSystemListData, // 信用制度列表
    savePortalSystemListData,
    portalSystemDetail,
    submitPortalSystemListData,
    deletePortalSystemListData,

    getPortalAdministrativePenaltiesListData, // 信用制度列表
    savePortalAdministrativePenaltiesListData,
    portalAdministrativePenaltiesDetail,
    submitPortalAdministrativePenaltiesListData,
    deletePortalAdministrativePenaltiesListData,

    getInfomationPublishListData,
    saveInfomationPublishData,
    getInfomationPublishDetail,
    submitInfomationPublishData,
    deleteInfomationPublishData,
    revokeInfomationPublishData,
    getPortalPoliciesRegulationListData,
    savePortalPoliciesRegulationData,
    getPortalPoliciesRegulationDetail,
    submitPortalPoliciesRegulationData,
    revokePortalPoliciesRegulationData,
    deletePortalPoliciesRegulationData,
}